import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Button, Card, CardContent, CardHeader, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { GrNext } from "react-icons/gr";

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';
import "moment/locale/es-mx";

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';
import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';

import { InputSearchStyle, InputSearchButtonsStyle } from '../../../styles/FormStyle';

import { ActualizarEstatus, RegistrarInformacion } from '../../../connections/comun/RecepcionConnection';
import { ObtenerTipoJuicioPorMateria } from '../../../connections/catalogos/TipoJuicioMateriaConnection';
import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';

import { PresentanteProps } from '../../../interfaces/comun/PersonaInterface';
import { TipoJuicioProps } from '../../../interfaces/catalogos/TipoJuicioInterface';
import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { RegistrarInformacionParams } from '../../../interfaces/comun/RecepcionInterface';

interface Props {
    numeroSeguimiento:      number;
    handleNext:             () => void;
}

export const RegistrarInformacionPage = ( { numeroSeguimiento, handleNext } : Props ) => {    

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const DateNow = moment( new Date()).format("YYYY-MM-DDTHH:mm");

    const [presentante, setPresentante] = useState<PresentanteProps>( { idPersona: 0, nombreCompleto: '' } );    

    const [materia, setMateria] = useState( 0 );
    const [materiaTemp, setMateriaTemp] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [tipoJuicio, setTipoJuicio] = useState( 0 );
    const [tipoJuicioTemp, setTipoJuicioTemp] = useState( 0 );
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );

    const [fechaReloj, setFechaReloj] = useState( DateNow );
    const [recibidoReloj, setRecibidoReloj] = useState( false );   

    const [cuantia, setCuantia] = useState( '' );

    const [loadingNext, setLoadingNext] = useState( false );
    const [loadingSave, setLoadingSave] = useState( false );

    const [recibidoPaqueteria, setRecibidoPaqueteria] = useState( false );

    const [openDialogNuevaPersona, setopenDialogNuevaPersona] = useState(false);    
    const [openDialogBuscarPersona, setopenDialogBuscarPersona] = useState(false);

    const { idPersona, nombreCompleto } = presentante;

    const seleccionarPersona = ( persona: PresentanteProps ) => setPresentante( persona )    

    const validateFiels = () => {

        let valid = true;
        
        if( idPersona === 0 && !recibidoPaqueteria ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un presentante', variant: 'warning' }));     
        }
        
        if( materia === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la materia', variant: 'warning' }));     
        }

        if( ( materia === 5 || materia === 6 ) && cuantia === '' ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes escribir la cuantía', variant: 'warning' }));     
        }

        if( tipoJuicio === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de juicio', variant: 'warning' }));     
        }
        
        if( fechaReloj === '' && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la fecha de reloj', variant: 'warning' }));     
        }
        else if( moment( new Date( fechaReloj ) ) > moment( new Date( ) ) && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'La fecha de reloj no puede ser mayor a la fecha actual', variant: 'warning' }));     
        }              

        return valid;
    } 

    const Guardar = async () => {

        const params: RegistrarInformacionParams = { 
            id: recepcion.id ?? '', 
            fechaReloj: recibidoReloj ? fechaReloj : '', 
            idMateria: materia, 
            idPresentante: idPersona, 
            idTipoJuicio: tipoJuicio, 
            recibidoPaqueteria: recibidoPaqueteria, 
            recibidoPorReloj: recibidoReloj,
            cuantia,
        };

        const request = await RegistrarInformacion( params );  

        if( request.success ){

            const tipoJuicioDescripcion = tipoJuicioArray.find( (e) => e.idTipoJuicio === tipoJuicio )?.descripcion ?? '';
            const materiaDescripcion = materiaArray.find( (e) => e.idMateria === materia )?.descripcion ?? '';

            dispatch( setReducerRecepcion({ 
                ...recepcion, 
                ...params, 
                tipoJuicio: tipoJuicioDescripcion, 
                materia: materiaDescripcion, 
                presentante: recibidoPaqueteria ? 'Enviado por paquetería' : nombreCompleto, 
                cuantia,
            }));
        }

        return request;
    }

    const handleGuardar = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );
                    dispatch( openSnackbar({ message: 'Se guardó la información correctamente', variant: 'success' }));   

                }, 700);
            }
            else {

                setTimeout(() => {                    
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleSiguiente = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingNext( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {                    
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));   
                    
                    setLoadingNext( false );
    
                }, 700);
            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 4 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingNext( false );
                    handleNext();

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    
                    setLoadingNext( false );

                }, 700);

            }

        });       

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerMateria().then( resp => {  
                setMateriaArray( resp );    
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){

            setTipoJuicio( 0 );
            setTipoJuicioArray( [] );    

            if( materia !== 0 ){

                await ObtenerTipoJuicioPorMateria( materia ).then( resp => {  
                    setTipoJuicioArray( resp );    
                });

            }            

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {
        
        if( recepcion.id ){

            setRecibidoPaqueteria( recepcion.recibidoPaqueteria ?? false );
            setRecibidoReloj( recepcion.recibidoPorReloj ?? false );
            setFechaReloj( recepcion.fechaReloj ?? '' );
            setCuantia( recepcion.cuantia ?? '' );

            setPresentante( { idPersona: recepcion.idPresentante ?? 0, nombreCompleto: recepcion.presentante ?? '', } );

            setMateriaTemp( recepcion.idMateria ?? 0 );
            setTipoJuicioTemp( recepcion.idTipoJuicio ?? 0 );

        }

    }, [ recepcion ]);

    useEffect(() => {
        
        if( materiaArray.length !== 0 && materiaTemp !== 0 ){
            setMateria( materiaTemp );
        }

    }, [ materiaArray, materiaTemp ]);

    useEffect(() => {
        
        if( tipoJuicioArray.length !== 0 && tipoJuicioTemp !== 0 ){
            setTipoJuicio( tipoJuicioTemp );
        }

    }, [ tipoJuicioArray, tipoJuicioTemp ]);
       
    return (
        <>
            <Grid container spacing={3}>    

                <Grid size={{ md: 12, xs: 12 }}>       

                    <Card sx={{ mt: 2 }}>
                    
                        <CardHeader 
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                            subheader={ 
                                <Grid container spacing={3}>

                                    <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                        <Typography variant='h6' sx={{ color: 'white' }}> Registrar información </Typography> 
                                    </Grid>
                                
                                    <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                        <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                    </Grid>

                                </Grid>
                            }
                        />
                    
                        <CardContent sx={{ p: 3 }}>
                        
                            <Grid container spacing={3}>   

                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: !recibidoPaqueteria ? 4 : 12, xs: 12 }}>

                                            <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                                <FormLabel>¿El trámite es recibido por paquetería?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === false } onChange={ ( e ) => { setRecibidoPaqueteria( false ); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="No" />
                                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === true } onChange={  ( e ) => { setRecibidoPaqueteria( true); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="Si" />
                                                </RadioGroup>

                                            </FormControl>

                                        </Grid>
                                }                                

                                {
                                    !recibidoPaqueteria
                                    &&
                                        <Grid size={{ md: 8, xs: 12 }} > 

                                            {
                                                ( !recepcion.acuseFirmado && !recepcion.provieneBuzonElectronico )
                                                ?
                                                    <Paper component="div" sx={ InputSearchStyle } >    

                                                        <InputBase 
                                                            sx={{ ml: 1, flex: 1 }} 
                                                            inputProps={{ 'aria-label': 'Buscar presentante' }} 
                                                            placeholder="Buscar presentante"     
                                                            name="presentante"
                                                            value={ nombreCompleto }   
                                                            onChange={ () => {} }             
                                                            autoComplete="off"   
                                                            disabled
                                                        /> 
                                                    
                                                        <Button 
                                                            size='small'
                                                            variant='contained' 
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogBuscarPersona( true ) }
                                                        >
                                                            <SearchIcon />
                                                        </Button>     
                                                            
                                                        <Button 
                                                            variant='contained' 
                                                            size='small'
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogNuevaPersona( true ) }
                                                        >
                                                            <PersonAddIcon />
                                                        </Button>     

                                                    </Paper> 
                                                :
                                                    <>
                                                        <Typography variant='subtitle2' color='textSecondary'>Presentante:</Typography>
                                                        <Typography variant='subtitle2' color='textSecondary'>{ nombreCompleto }</Typography>                                                    
                                                    </>
                                            }

                                        </Grid>                      
                                }   
                                
                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>                            

                                            <FormControl disabled={ recepcion.acuseFirmado !== '' }>
                                                
                                                <FormLabel>¿El trámite es recibido por reloj?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === true } onChange={ () => { setRecibidoReloj( true ); setFechaReloj( DateNow ); }} />} label="Si" />                        
                                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === false } onChange={ () => setRecibidoReloj( false ) } />} label="No" />    
                                                </RadioGroup>

                                            </FormControl>

                                        </Grid>
                                }

                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>                            

                                            {
                                                recibidoReloj 
                                                &&                                                                                   
                                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es"> 

                                                        <DateTimePicker                                        
                                                            label="Fecha de recepción por reloj"       
                                                            sx={{ width: '100%' }}  
                                                            disabled={ recepcion.acuseFirmado !== '' }
                                                            value={ moment( fechaReloj ) }
                                                            maxDate={ moment( new Date() ) }
                                                            onChange={ (e) => setFechaReloj( moment( e ).format( 'YYYY-MM-DDTHH:mm' ) ) }
                                                        />    

                                                    </LocalizationProvider>      
                                            }

                                        </Grid>   
                                }

                                <Grid size={{ md: ( materia === 5 || materia === 6 ) ? 8 : 6, xs: 12 }}>      

                                    <FormControl disabled={ recepcion.acuseFirmado !== '' || recepcion.provieneBuzonElectronico }>

                                        <FormLabel>Seleccione la materia</FormLabel>
                                        <RadioGroup row>
                                            {
                                                materiaArray
                                                .map( ({ idMateria, descripcion }) => (
                                                    <FormControlLabel 
                                                        key={ idMateria }
                                                        label={ descripcion }
                                                        control={ <Radio checked={ materia === idMateria } 
                                                        onChange={ () => setMateria( idMateria ) } />} 
                                                    />                        
                                                ))
                                            }                                      
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>

                                {
                                    ( materia === 5 || materia === 6 )
                                    &&
                                        <Grid size={{ md: 4, xs: 12 }}>  
                                            <TextField
                                                fullWidth
                                                required     
                                                label="Cuantía"                                             
                                                variant="outlined"        
                                                type='number'
                                                autoComplete="off"   
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}         
                                                disabled={ recepcion.acuseFirmado !== '' }        
                                                value={ cuantia }   
                                                onChange={ ( e ) => { setCuantia( e.target.value ); } }
                                            />
                                        </Grid>
                                }

                                <Grid size={{ md: 12, xs: 12 }}>                            
                                
                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de juicio</InputLabel>
                                    
                                        <Select                                                                              
                                            label="Tipo de juicio"
                                            value={ tipoJuicio }
                                            onChange={ (e) => setTipoJuicio( e.target.value )  }
                                            disabled={ materia === 0 || recepcion.acuseFirmado !== '' || recepcion.provieneBuzonElectronico }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                tipoJuicioArray.map( ({ idTipoJuicio, descripcion  }) => (
                                                    <MenuItem key={idTipoJuicio} value={idTipoJuicio}>{ descripcion }</MenuItem>   
                                                ))
                                            }
                                        </Select>

                                    </FormControl>
                                
                                </Grid>                                   
                                
                            </Grid> 

                        </CardContent>
                    
                    </Card>  
                
                </Grid>

                <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>  

                    <Grid container spacing={3}>

                        <Grid size={{ md: 4, xs: 12 }}>

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center '}}>

                            {
                                ( !recepcion.acuseFirmado && !recepcion.provieneBuzonElectronico )
                                &&
                                    <Button 
                                        fullWidth
                                        variant="contained"                                      
                                        onClick={ handleGuardar }
                                        loading={ loadingSave }
                                    > 
                                        Guardar 
                                    </Button>
                            }

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'end '}}>

                            <IconButton     
                                color='primary'                     
                                onClick={ handleSiguiente }
                                loading={ loadingNext }
                            > 
                                <GrNext />
                            </IconButton>

                        </Grid>

                    </Grid>              

                </Grid>

            </Grid> 

            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setopenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setopenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            /> 
        
        </>        
    );
}
